import React,{ useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import StatisticsBox from './StatisticsBox.js';
import {isMobile} from 'react-device-detect';

function Pool() {
    const state = useSelector((state)=>state);
    const dispatch = useDispatch();

    function SpanClassName(params) {
        if(state.Result.length!==0)
        {
            let converIndex = params;
            if(155 < state.Result.length)
            {
                converIndex = state.Result.length - 155 + params;
            }

            if(state.Result.length-1 < converIndex)
            {
                return '';
            }
            
            if(state.Result[converIndex] ==='P')
            return 'pl';
            else if(state.Result[converIndex] ==='B')
            return 'bk';
            else if(state.Result[converIndex] === 'T')
            return 'ti';
        
        }
        return '';
    }
    function SpanText(params) {
        if(state.Result.length!==0)
        {
            let converIndex = params;
            if(155 < state.Result.length)
            {
                converIndex = state.Result.length - 155 + params;
            }

            if(state.Result.length-1 < converIndex)
            {
                return '';
            }

            if(state.Result[converIndex] === 'P')
            return  'P';
            else if(state.Result[converIndex] === 'B')
            return  'B';
            else if(state.Result[converIndex] === 'T')
            return 'T';
        }
        return '';
    }
    function ExistEm(params) {
        return '';
    }

    function Pool_Scale() {
        return '';
        /*
        const off='current-pool-move-on 0.5s linear forwards';
        const on='current-pool-move-off 0.5s linear forwards';
        
        if(state.TimerInfo.Time===0 || state.Ins === true)
        {
          return off;
        }
        else if(state.TimerInfo.Time>0)
        {
          return on;
        }
        */
      }

      function smallE(a,b) {
        if(state.smallRoad!==null)
        {
            let item = state.smallRoad.getItem(a,b);
            //undefined 검사
            if(item!==undefined)
            {
                //left
                if(b%2===0)
                {
                    //Red
                    if(item.repetition===true)
                    {
                        //top
                        if(a%2===0)
                        return "r-lt";
                        else
                        return "r-lb";
                    }
                    else if(item.repetition===false)
                    {
                        if(a%2===0)
                        return "b-lt";
                        else
                        return "b-lb";
                    }
                    
                }
                else //right
                {
                    //Red
                    if(item.repetition===true)
                    {
                        //top
                        if(a%2===0)
                        return "r-rt";
                        else
                        return "r-rb";
                    }
                    else if(item.repetition===false)
                    {
                        if(a%2===0)
                        return "b-rt";
                        else
                        return "b-rb";
                    }
                    
                }
            }
            else
            return '';
        }

    }

    return(
        <div className='result-guide-box'>
            <StatisticsBox></StatisticsBox>
            <div className="current_pool">
                <div className="right-slide">
                    <div className="current-box">
                        <div className="result-table">
                            {Array.from({length:16}).map((_, index)=>(
                                <ul key={index}>
                                    {Array.from({length:6}).map((_,LiIndex)=>(
                                        <li key={LiIndex+1}>
                                            <span className={SpanClassName((index*6)+LiIndex)}>
                                                {SpanText((index*6)+LiIndex)}
                                                {ExistEm((index*6)+LiIndex)}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            ))}
                        </div>
                    </div>
                    <div className="this-table-2">
                            <div className='two-point'>
                            {/* 2군 */}
                            <ul>
                                <li>
                                    <span className={smallE(0,0)}></span>
                                    <span className={smallE(0,1)}></span>
                                    <span className={smallE(1,0)}></span>
                                    <span className={smallE(1,1)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,0)}></span>
                                    <span className={smallE(2,1)}></span>
                                    <span className={smallE(3,0)}></span>
                                    <span className={smallE(3,1)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,0)}></span>
                                    <span className={smallE(4,1)}></span>
                                    <span className={smallE(5,0)}></span>
                                    <span className={smallE(5,1)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,2)}></span>
                                    <span className={smallE(0,3)}></span>
                                    <span className={smallE(1,2)}></span>
                                    <span className={smallE(1,3)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,2)}></span>
                                    <span className={smallE(2,3)}></span>
                                    <span className={smallE(3,2)}></span>
                                    <span className={smallE(3,3)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,2)}></span>
                                    <span className={smallE(4,3)}></span>
                                    <span className={smallE(5,2)}></span>
                                    <span className={smallE(5,3)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,4)}></span>
                                    <span className={smallE(0,5)}></span>
                                    <span className={smallE(1,4)}></span>
                                    <span className={smallE(1,5)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,4)}></span>
                                    <span className={smallE(2,5)}></span>
                                    <span className={smallE(3,4)}></span>
                                    <span className={smallE(3,5)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,4)}></span>
                                    <span className={smallE(4,5)}></span>
                                    <span className={smallE(5,4)}></span>
                                    <span className={smallE(5,5)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,6)}></span>
                                    <span className={smallE(0,7)}></span>
                                    <span className={smallE(1,6)}></span>
                                    <span className={smallE(1,7)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,6)}></span>
                                    <span className={smallE(2,7)}></span>
                                    <span className={smallE(3,6)}></span>
                                    <span className={smallE(3,7)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,6)}></span>
                                    <span className={smallE(4,7)}></span>
                                    <span className={smallE(5,6)}></span>
                                    <span className={smallE(5,7)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,8)}></span>
                                    <span className={smallE(0,9)}></span>
                                    <span className={smallE(1,8)}></span>
                                    <span className={smallE(1,9)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,8)}></span>
                                    <span className={smallE(2,9)}></span>
                                    <span className={smallE(3,8)}></span>
                                    <span className={smallE(3,9)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,8)}></span>
                                    <span className={smallE(4,9)}></span>
                                    <span className={smallE(5,8)}></span>
                                    <span className={smallE(5,9)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,10)}></span>
                                    <span className={smallE(0,11)}></span>
                                    <span className={smallE(1,10)}></span>
                                    <span className={smallE(1,11)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,10)}></span>
                                    <span className={smallE(2,11)}></span>
                                    <span className={smallE(3,10)}></span>
                                    <span className={smallE(3,11)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,10)}></span>
                                    <span className={smallE(4,11)}></span>
                                    <span className={smallE(5,10)}></span>
                                    <span className={smallE(5,11)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,12)}></span>
                                    <span className={smallE(0,13)}></span>
                                    <span className={smallE(1,12)}></span>
                                    <span className={smallE(1,13)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,12)}></span>
                                    <span className={smallE(2,13)}></span>
                                    <span className={smallE(3,12)}></span>
                                    <span className={smallE(3,13)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,12)}></span>
                                    <span className={smallE(4,13)}></span>
                                    <span className={smallE(5,12)}></span>
                                    <span className={smallE(5,13)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,14)}></span>
                                    <span className={smallE(0,15)}></span>
                                    <span className={smallE(1,14)}></span>
                                    <span className={smallE(1,15)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,14)}></span>
                                    <span className={smallE(2,15)}></span>
                                    <span className={smallE(3,14)}></span>
                                    <span className={smallE(3,15)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,14)}></span>
                                    <span className={smallE(4,15)}></span>
                                    <span className={smallE(5,14)}></span>
                                    <span className={smallE(5,15)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,16)}></span>
                                    <span className={smallE(0,17)}></span>
                                    <span className={smallE(1,16)}></span>
                                    <span className={smallE(1,17)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,16)}></span>
                                    <span className={smallE(2,17)}></span>
                                    <span className={smallE(3,16)}></span>
                                    <span className={smallE(3,17)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,16)}></span>
                                    <span className={smallE(4,17)}></span>
                                    <span className={smallE(5,16)}></span>
                                    <span className={smallE(5,17)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,18)}></span>
                                    <span className={smallE(0,19)}></span>
                                    <span className={smallE(1,18)}></span>
                                    <span className={smallE(1,19)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,18)}></span>
                                    <span className={smallE(2,19)}></span>
                                    <span className={smallE(3,18)}></span>
                                    <span className={smallE(3,19)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,18)}></span>
                                    <span className={smallE(4,19)}></span>
                                    <span className={smallE(5,18)}></span>
                                    <span className={smallE(5,19)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,20)}></span>
                                    <span className={smallE(0,21)}></span>
                                    <span className={smallE(1,20)}></span>
                                    <span className={smallE(1,21)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,20)}></span>
                                    <span className={smallE(2,21)}></span>
                                    <span className={smallE(3,20)}></span>
                                    <span className={smallE(3,21)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,20)}></span>
                                    <span className={smallE(4,21)}></span>
                                    <span className={smallE(5,20)}></span>
                                    <span className={smallE(5,21)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,22)}></span>
                                    <span className={smallE(0,23)}></span>
                                    <span className={smallE(1,22)}></span>
                                    <span className={smallE(1,23)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,22)}></span>
                                    <span className={smallE(2,23)}></span>
                                    <span className={smallE(3,22)}></span>
                                    <span className={smallE(3,23)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,22)}></span>
                                    <span className={smallE(4,23)}></span>
                                    <span className={smallE(5,22)}></span>
                                    <span className={smallE(5,23)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,24)}></span>
                                    <span className={smallE(0,25)}></span>
                                    <span className={smallE(1,24)}></span>
                                    <span className={smallE(1,25)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,24)}></span>
                                    <span className={smallE(2,25)}></span>
                                    <span className={smallE(3,24)}></span>
                                    <span className={smallE(3,25)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,24)}></span>
                                    <span className={smallE(4,25)}></span>
                                    <span className={smallE(5,24)}></span>
                                    <span className={smallE(5,25)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,26)}></span>
                                    <span className={smallE(0,27)}></span>
                                    <span className={smallE(1,26)}></span>
                                    <span className={smallE(1,27)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,26)}></span>
                                    <span className={smallE(2,27)}></span>
                                    <span className={smallE(3,26)}></span>
                                    <span className={smallE(3,27)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,26)}></span>
                                    <span className={smallE(4,27)}></span>
                                    <span className={smallE(5,26)}></span>
                                    <span className={smallE(5,27)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,28)}></span>
                                    <span className={smallE(0,29)}></span>
                                    <span className={smallE(1,28)}></span>
                                    <span className={smallE(1,29)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,28)}></span>
                                    <span className={smallE(2,29)}></span>
                                    <span className={smallE(3,28)}></span>
                                    <span className={smallE(3,29)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,28)}></span>
                                    <span className={smallE(4,29)}></span>
                                    <span className={smallE(5,28)}></span>
                                    <span className={smallE(5,29)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,30)}></span>
                                    <span className={smallE(0,31)}></span>
                                    <span className={smallE(1,30)}></span>
                                    <span className={smallE(1,31)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,30)}></span>
                                    <span className={smallE(2,31)}></span>
                                    <span className={smallE(3,30)}></span>
                                    <span className={smallE(3,31)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,30)}></span>
                                    <span className={smallE(4,31)}></span>
                                    <span className={smallE(5,30)}></span>
                                    <span className={smallE(5,31)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,32)}></span>
                                    <span className={smallE(0,33)}></span>
                                    <span className={smallE(1,32)}></span>
                                    <span className={smallE(1,33)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,32)}></span>
                                    <span className={smallE(2,33)}></span>
                                    <span className={smallE(3,32)}></span>
                                    <span className={smallE(3,33)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,32)}></span>
                                    <span className={smallE(4,33)}></span>
                                    <span className={smallE(5,32)}></span>
                                    <span className={smallE(5,33)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,34)}></span>
                                    <span className={smallE(0,35)}></span>
                                    <span className={smallE(1,34)}></span>
                                    <span className={smallE(1,35)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,34)}></span>
                                    <span className={smallE(2,35)}></span>
                                    <span className={smallE(3,34)}></span>
                                    <span className={smallE(3,35)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,34)}></span>
                                    <span className={smallE(4,35)}></span>
                                    <span className={smallE(5,34)}></span>
                                    <span className={smallE(5,35)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,36)}></span>
                                    <span className={smallE(0,37)}></span>
                                    <span className={smallE(1,36)}></span>
                                    <span className={smallE(1,37)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,36)}></span>
                                    <span className={smallE(2,37)}></span>
                                    <span className={smallE(3,36)}></span>
                                    <span className={smallE(3,37)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,36)}></span>
                                    <span className={smallE(4,37)}></span>
                                    <span className={smallE(5,36)}></span>
                                    <span className={smallE(5,37)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,38)}></span>
                                    <span className={smallE(0,39)}></span>
                                    <span className={smallE(1,38)}></span>
                                    <span className={smallE(1,39)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,38)}></span>
                                    <span className={smallE(2,39)}></span>
                                    <span className={smallE(3,38)}></span>
                                    <span className={smallE(3,39)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,38)}></span>
                                    <span className={smallE(4,39)}></span>
                                    <span className={smallE(5,38)}></span>
                                    <span className={smallE(5,39)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,40)}></span>
                                    <span className={smallE(0,41)}></span>
                                    <span className={smallE(1,40)}></span>
                                    <span className={smallE(1,41)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,40)}></span>
                                    <span className={smallE(2,41)}></span>
                                    <span className={smallE(3,40)}></span>
                                    <span className={smallE(3,41)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,40)}></span>
                                    <span className={smallE(4,41)}></span>
                                    <span className={smallE(5,40)}></span>
                                    <span className={smallE(5,41)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,42)}></span>
                                    <span className={smallE(0,43)}></span>
                                    <span className={smallE(1,42)}></span>
                                    <span className={smallE(1,43)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,42)}></span>
                                    <span className={smallE(2,43)}></span>
                                    <span className={smallE(3,42)}></span>
                                    <span className={smallE(3,43)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,42)}></span>
                                    <span className={smallE(4,43)}></span>
                                    <span className={smallE(5,42)}></span>
                                    <span className={smallE(5,43)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,44)}></span>
                                    <span className={smallE(0,45)}></span>
                                    <span className={smallE(1,44)}></span>
                                    <span className={smallE(1,45)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,44)}></span>
                                    <span className={smallE(2,45)}></span>
                                    <span className={smallE(3,44)}></span>
                                    <span className={smallE(3,45)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,44)}></span>
                                    <span className={smallE(4,45)}></span>
                                    <span className={smallE(5,44)}></span>
                                    <span className={smallE(5,45)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,46)}></span>
                                    <span className={smallE(0,47)}></span>
                                    <span className={smallE(1,46)}></span>
                                    <span className={smallE(1,47)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,46)}></span>
                                    <span className={smallE(2,47)}></span>
                                    <span className={smallE(3,46)}></span>
                                    <span className={smallE(3,47)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,46)}></span>
                                    <span className={smallE(4,47)}></span>
                                    <span className={smallE(5,46)}></span>
                                    <span className={smallE(5,47)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,48)}></span>
                                    <span className={smallE(0,49)}></span>
                                    <span className={smallE(1,48)}></span>
                                    <span className={smallE(1,49)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,48)}></span>
                                    <span className={smallE(2,49)}></span>
                                    <span className={smallE(3,48)}></span>
                                    <span className={smallE(3,49)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,48)}></span>
                                    <span className={smallE(4,49)}></span>
                                    <span className={smallE(5,48)}></span>
                                    <span className={smallE(5,49)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,50)}></span>
                                    <span className={smallE(0,51)}></span>
                                    <span className={smallE(1,50)}></span>
                                    <span className={smallE(1,51)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,50)}></span>
                                    <span className={smallE(2,51)}></span>
                                    <span className={smallE(3,50)}></span>
                                    <span className={smallE(3,51)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,50)}></span>
                                    <span className={smallE(4,51)}></span>
                                    <span className={smallE(5,50)}></span>
                                    <span className={smallE(5,51)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,52)}></span>
                                    <span className={smallE(0,53)}></span>
                                    <span className={smallE(1,52)}></span>
                                    <span className={smallE(1,53)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,52)}></span>
                                    <span className={smallE(2,53)}></span>
                                    <span className={smallE(3,52)}></span>
                                    <span className={smallE(3,53)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,52)}></span>
                                    <span className={smallE(4,53)}></span>
                                    <span className={smallE(5,52)}></span>
                                    <span className={smallE(5,53)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,54)}></span>
                                    <span className={smallE(0,55)}></span>
                                    <span className={smallE(1,54)}></span>
                                    <span className={smallE(1,55)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,54)}></span>
                                    <span className={smallE(2,55)}></span>
                                    <span className={smallE(3,54)}></span>
                                    <span className={smallE(3,55)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,54)}></span>
                                    <span className={smallE(4,55)}></span>
                                    <span className={smallE(5,54)}></span>
                                    <span className={smallE(5,55)}></span>
                                </li>
                            </ul>

                            <ul>
                                <li>
                                    <span className={smallE(0,56)}></span>
                                    <span className={smallE(0,57)}></span>
                                    <span className={smallE(1,56)}></span>
                                    <span className={smallE(1,57)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,56)}></span>
                                    <span className={smallE(2,57)}></span>
                                    <span className={smallE(3,56)}></span>
                                    <span className={smallE(3,57)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,56)}></span>
                                    <span className={smallE(4,57)}></span>
                                    <span className={smallE(5,56)}></span>
                                    <span className={smallE(5,57)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,58)}></span>
                                    <span className={smallE(0,59)}></span>
                                    <span className={smallE(1,58)}></span>
                                    <span className={smallE(1,59)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,58)}></span>
                                    <span className={smallE(2,59)}></span>
                                    <span className={smallE(3,58)}></span>
                                    <span className={smallE(3,59)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,58)}></span>
                                    <span className={smallE(4,59)}></span>
                                    <span className={smallE(5,58)}></span>
                                    <span className={smallE(5,59)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,60)}></span>
                                    <span className={smallE(0,61)}></span>
                                    <span className={smallE(1,60)}></span>
                                    <span className={smallE(1,61)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,60)}></span>
                                    <span className={smallE(2,61)}></span>
                                    <span className={smallE(3,60)}></span>
                                    <span className={smallE(3,61)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,60)}></span>
                                    <span className={smallE(4,61)}></span>
                                    <span className={smallE(5,60)}></span>
                                    <span className={smallE(5,61)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,62)}></span>
                                    <span className={smallE(0,63)}></span>
                                    <span className={smallE(1,62)}></span>
                                    <span className={smallE(1,63)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,62)}></span>
                                    <span className={smallE(2,63)}></span>
                                    <span className={smallE(3,62)}></span>
                                    <span className={smallE(3,63)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,62)}></span>
                                    <span className={smallE(4,63)}></span>
                                    <span className={smallE(5,62)}></span>
                                    <span className={smallE(5,63)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,64)}></span>
                                    <span className={smallE(0,65)}></span>
                                    <span className={smallE(1,64)}></span>
                                    <span className={smallE(1,65)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,64)}></span>
                                    <span className={smallE(2,65)}></span>
                                    <span className={smallE(3,64)}></span>
                                    <span className={smallE(3,65)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,64)}></span>
                                    <span className={smallE(4,65)}></span>
                                    <span className={smallE(5,64)}></span>
                                    <span className={smallE(5,65)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,66)}></span>
                                    <span className={smallE(0,67)}></span>
                                    <span className={smallE(1,66)}></span>
                                    <span className={smallE(1,67)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,66)}></span>
                                    <span className={smallE(2,67)}></span>
                                    <span className={smallE(3,66)}></span>
                                    <span className={smallE(3,67)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,66)}></span>
                                    <span className={smallE(4,67)}></span>
                                    <span className={smallE(5,66)}></span>
                                    <span className={smallE(5,67)}></span>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <span className={smallE(0,68)}></span>
                                    <span className={smallE(0,69)}></span>
                                    <span className={smallE(1,68)}></span>
                                    <span className={smallE(1,69)}></span>
                                </li>
                                <li>
                                    <span className={smallE(2,68)}></span>
                                    <span className={smallE(2,69)}></span>
                                    <span className={smallE(3,68)}></span>
                                    <span className={smallE(3,69)}></span>
                                </li>
                                <li>
                                    <span className={smallE(4,68)}></span>
                                    <span className={smallE(4,69)}></span>
                                    <span className={smallE(5,68)}></span>
                                    <span className={smallE(5,69)}></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    );
}


export default Pool;